import { useMutation } from '@apollo/client';
import { graphql } from 'gql.tada';

const SendFamilyInvitesMutation = graphql.persisted(
  "SendFamilyInvites",
  graphql(`
    mutation SendFamilyInvites($familyEnrollmentIds: [ID!]!) {
      sendFamilyInvites(input: {familyEnrollmentIds: $familyEnrollmentIds}) {
        familyEnrollments {
          id
          state
          inviteStatus
          inviteToken
          sentAt
          canSendInvite
        }
        sentCount
        failedCount
        userErrors {
          message
          path
        }
      }
    }
  `)
);

export { SendFamilyInvitesMutation };

export function useSendFamilyInvites() {
  return useMutation(SendFamilyInvitesMutation);
}
